import { render, staticRenderFns } from "./ManufacturersView.vue?vue&type=template&id=1b24f0ca"
import script from "./ManufacturersView.vue?vue&type=script&lang=js"
export * from "./ManufacturersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports